/* eslint-disable max-lines */
import { color } from 'styles/colors'

const INDOOR_LEGEND_ITEMS = [
  {
    label: 'Cooling Setpoint',
    seriesName: 'cooling',
    emptyDataSet: true,
    strokeDasharray: '2, 2',
    stroke: color('legendIndoor'),
    strokeWidth: '3',
    strokeLineCap: 'butt',
    visible: true,
    x1: '0',
    y1: ' 0',
    x2: '24',
    y2: '0'
  },
  {
    label: 'Heating Setpoint',
    seriesName: 'heating',
    emptyDataSet: true,
    strokeDasharray: '3, 3',
    stroke: color('legendIndoor'),
    strokeWidth: '3',
    strokeLineCap: 'butt',
    visible: true,
    x1: '0',
    y1: ' 0',
    x2: '24',
    y2: '0'
  },
  {
    label: 'ID Temperature',
    seriesName: 'indoorTemp',
    emptyDataSet: true,
    strokeDasharray: '8 0',
    stroke: color('legendIndoor'),
    strokeWidth: '6',
    strokeLineCap: 'butt',
    visible: true,
    x1: '0',
    y1: ' 0',
    x2: '24',
    y2: '0'
  },
  {
    label: 'ID Relative Humidity',
    seriesName: 'indoorHumidity',
    emptyDataSet: true,
    strokeDasharray: '16, 2, 3 ',
    stroke: color('legendIndoor'),
    strokeWidth: '6',
    strokeLineCap: 'butt',
    visible: true,
    x1: '0',
    y1: ' 0',
    x2: '24',
    y2: '0'
  }
]

const INDOOR_ZONE_LEGEND_ITEMS = INDOOR_LEGEND_ITEMS.concat({
  label: 'Relieving',
  seriesName: 'relieving',
  emptyDataSet: true,
  strokeDasharray: '',
  stroke: color('legendRelieving'),
  strokeWidth: '6',
  strokeLineCap: 'round',
  visible: true,
  x1: '3',
  y1: '3',
  x2: '16',
  y2: '3'
})

const OUTDOOR_LEGEND_ITEMS = [
  {
    label: 'OD Temperature',
    seriesName: 'outdoorTemp',
    emptyDataSet: true,
    strokeDasharray: '',
    stroke: color('legendOutdoor'),
    strokeWidth: '6',
    strokeLineCap: 'butt',
    visible: true,
    x1: '0',
    y1: ' 0',
    x2: '24',
    y2: '0'
  },
  {
    label: 'OD Relative Humidity',
    seriesName: 'outdoorHumidity',
    emptyDataSet: true,
    strokeDasharray: '20,2,2',
    strokeWidth: '6',
    stroke: color('legendOutdoor'),
    strokeLineCap: 'butt',
    visible: true,
    x1: '0',
    y1: ' 0',
    x2: '24',
    y2: '0'
  }
]

const OUTDOOR_UNIT_LEGEND_ITEMS = [
  {
    label: 'Liquid Pressure',
    seriesName: 'liquidPressure',
    emptyDataSet: true,
    strokeDasharray: '24,0',
    stroke: color('legendOdLiquidPressure'),
    strokeLineCap: 'butt',
    strokeWidth: '6',
    visible: false,
    x1: '0',
    y1: ' 0',
    x2: '24',
    y2: '0'
  },
  {
    label: 'Liquid Temp',
    seriesName: 'odLiquidTemp',
    emptyDataSet: true,
    strokeDasharray: '24,0',
    stroke: color('legendOdLiquidTemp'),
    strokeLineCap: 'butt',
    strokeWidth: '6',
    visible: false,
    x1: '0',
    y1: ' 0',
    x2: '24',
    y2: '0'
  },
  {
    label: 'OD Subcool',
    seriesName: 'odSubcool',
    emptyDataSet: true,
    strokeDasharray: '24,0',
    stroke: color('legendOdSubCool'),
    strokeLineCap: 'butt',
    strokeWidth: '6',
    visible: false,
    x1: '0',
    y1: ' 0',
    x2: '24',
    y2: '0'
  },
  {
    label: 'Suction Pressure',
    seriesName: 'odSuctionPressure',
    emptyDataSet: true,
    strokeDasharray: '24,0',
    stroke: color('legendOdSuctionPressure'),
    strokeWidth: '6',
    strokeLineCap: 'butt',
    visible: false,
    x1: '0',
    y1: ' 0',
    x2: '24',
    y2: '0'
  },
  {
    label: 'Suction Temp',
    seriesName: 'suctionTemperature',
    emptyDataSet: true,
    strokeDasharray: '24,0',
    stroke: color('legendOdSuctionTemperature'),
    strokeLineCap: 'butt',
    strokeWidth: '6',
    visible: false,
    x1: '0',
    y1: ' 0',
    x2: '24',
    y2: '0'
  },
  {
    label: 'OD Superheat',
    seriesName: 'odSuperheat',
    emptyDataSet: true,
    strokeDasharray: '24,0',
    stroke: color('legendOdSuperheat'),
    strokeWidth: '6',
    strokeLineCap: 'butt',
    visible: false,
    x1: '0',
    y1: ' 0',
    x2: '24',
    y2: '0'
  },
  {
    label: 'OD EEV Position',
    seriesName: 'odEevStepPosition',
    emptyDataSet: true,
    strokeDasharray: '24,0',
    stroke: color('legendOdEevStepColor'),
    strokeWidth: '6',
    strokeLineCap: 'butt',
    visible: false,
    x1: '0',
    y1: ' 0',
    x2: '24',
    y2: '0'
  },
  {
    label: 'OD Coil Temp',
    seriesName: 'odCoilTemp',
    emptyDataSet: true,
    strokeDasharray: '24,0',
    stroke: color('legendOdCoilTemp'),
    strokeWidth: '6',
    strokeLineCap: 'butt',
    visible: false,
    x1: '0',
    y1: ' 0',
    x2: '24',
    y2: '0'
  },
  {
    label: 'Current',
    seriesName: 'odCurrent',
    emptyDataSet: true,
    strokeDasharray: '24,0',
    stroke: color('legendOdCurrent'),
    strokeWidth: '6',
    strokeLineCap: 'butt',
    visible: false,
    x1: '0',
    y1: ' 0',
    x2: '24',
    y2: '0'
  },
  {
    label: 'OD Gas Temp',
    seriesName: 'odGasTemp',
    emptyDataSet: true,
    strokeDasharray: '24,0',
    stroke: color('legendOdGasTemp'),
    strokeWidth: '6',
    strokeLineCap: 'butt',
    visible: false,
    x1: '0',
    y1: ' 0',
    x2: '24',
    y2: '0'
  },
  {
    label: 'OD Gas Pressure',
    seriesName: 'odGasPressure',
    emptyDataSet: true,
    strokeDasharray: '24,0',
    stroke: color('legendOdGasPressure'),
    strokeWidth: '6',
    strokeLineCap: 'butt',
    visible: false,
    x1: '0',
    y1: ' 0',
    x2: '24',
    y2: '0'
  }
]

const INDOOR_UNIT_LEGEND_ITEMS = [
  {
    label: 'Actual Airflow',
    seriesName: 'actualAirflow',
    emptyDataSet: true,
    strokeDasharray: '14, 2, 3, 2 ',
    stroke: color('indoorUnitActualAirflow'),
    strokeLineCap: 'butt',
    strokeWidth: '6',
    visible: false,
    x1: '0',
    y1: ' 0',
    x2: '24',
    y2: '0'
  },
  {
    label: 'ID Superheat',
    seriesName: 'gasSuperheat',
    emptyDataSet: true,
    strokeDasharray: '2, 2, 2, 2, 16',
    strokeLineCap: 'butt',
    strokeWidth: '6',
    stroke: color('legendIdSuperHeat'),
    visible: false,
    x1: '0',
    y1: '0',
    x2: '24',
    y2: '0'
  },
  {
    label: 'Gas Temp',
    seriesName: 'gasTemp',
    emptyDataSet: true,
    strokeDasharray: '2, 3, 19',
    strokeLineCap: 'butt',
    strokeWidth: '6',
    stroke: color('legendGasTemp'),
    visible: false,
    x1: '0',
    y1: '0',
    x2: '24',
    y2: '0'
  },
  {
    label: 'Evap/Liquid Temp',
    seriesName: 'coilTemp',
    emptyDataSet: true,
    strokeDasharray: '1,3, 20',
    stroke: color('legendIdCoilTemp'),
    strokeWidth: '6',
    strokeLineCap: 'butt',
    visible: false,
    x1: '0',
    y1: '0',
    x2: '24',
    y2: '0'
  }
]

const CONTROL_HUB_INDOOR_UNIT_LEGEND_ITEMS = [
  {
    label: 'ID EEV Steps',
    seriesName: 'idEevStep',
    emptyDataSet: true,
    strokeDasharray: '',
    stroke: color('legendIdEevStepColor'),
    strokeWidth: '6',
    strokeLineCap: 'butt',
    visible: false,
    x1: '0',
    y1: '0',
    x2: '24',
    y2: '0'
  },
  {
    label: 'ID Return Air Temp',
    seriesName: 'idReturnAirTemp',
    emptyDataSet: true,
    strokeDasharray: '',
    stroke: color('legendIdReturnAirTempColor'),
    strokeWidth: '6',
    strokeLineCap: 'butt',
    visible: false,
    x1: '0',
    y1: '0',
    x2: '24',
    y2: '0'
  },
  {
    label: 'ID Supply Air Temp',
    seriesName: 'idSupplyAirTemp',
    emptyDataSet: true,
    strokeDasharray: '',
    stroke: color('legendIdSupplyAirTempColor'),
    strokeWidth: '6',
    strokeLineCap: 'butt',
    visible: false,
    x1: '0',
    y1: '0',
    x2: '24',
    y2: '0'
  }
]

const HEHM_OUTDOOR_LEGEND_ITEMS = [
  ...OUTDOOR_LEGEND_ITEMS,
  ...OUTDOOR_UNIT_LEGEND_ITEMS.filter(item =>
    ['odLiquidTemp', 'liquidPressure', 'odGasTemp', 'odGasPressure'].includes(item.seriesName)
  )
]

const HEHM_INDOOR_LEGEND_ITEMS = [
  ...CONTROL_HUB_INDOOR_UNIT_LEGEND_ITEMS.filter(item =>
    ['idReturnAirTemp', 'idSupplyAirTemp'].includes(item.seriesName)
  )
]

const GAS_FURNACE_INDOOR_LEGEND_ITEMS = [
  ...INDOOR_UNIT_LEGEND_ITEMS.filter(item =>
    !['gasSuperheat', 'gasTemp', 'coilTemp'].includes(item.seriesName)
  )
]

const CONTROL_HUB_GAS_FURNACE_INDOOR_LEGEND_ITEMS = [
  ...CONTROL_HUB_INDOOR_UNIT_LEGEND_ITEMS.filter(item =>
    !['idEevStep'].includes(item.seriesName)
  )
]

const LegendConfig = {
  INDOOR_LEGEND_ITEMS,
  INDOOR_UNIT_LEGEND_ITEMS,
  INDOOR_ZONE_LEGEND_ITEMS,
  OUTDOOR_LEGEND_ITEMS,
  OUTDOOR_UNIT_LEGEND_ITEMS,
  CONTROL_HUB_INDOOR_UNIT_LEGEND_ITEMS,
  HEHM_OUTDOOR_LEGEND_ITEMS,
  HEHM_INDOOR_LEGEND_ITEMS,
  GAS_FURNACE_INDOOR_LEGEND_ITEMS,
  CONTROL_HUB_GAS_FURNACE_INDOOR_LEGEND_ITEMS
}

export default LegendConfig
